import type { FormApi } from "final-form";

export default function restartForm(form: FormApi<any, any>) {
  if (typeof form.restart === "function") {
    form.restart();
  } else {
    form.reset();
  }
}
